import {createTheme, responsiveFontSizes} from "@material-ui/core/styles";

const TOKEN = "TOKEN_STUDENT_CJ_VINA_EDU";
const TOKEN_ADMIN = "TOKEN_ADMIN_CJ_VINA_EDU";
const BASE_URL = "https://cjvinaedu.com.vn/api/v1";

let theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 500,
      md: 769,
      lg: 1025,
      xl: 1450,
    },
  },
  typography: {
    fontFamily: "Be Vietnam Pro",
  },
  overrides: {
    MuiTableCell: {
      footer: {
        left: 0,
        bottom: 0,
        zIndex: 10,
        position: "sticky",
        backgroundColor: "#fff",
      },
    },
    MuiAvatar: {
      img: {
        objectFit: "fill",
      },
    },
  },
});
theme = responsiveFontSizes(theme);
export {TOKEN, TOKEN_ADMIN, BASE_URL, theme};
